export const products = [
  {
    id: 1,
    name: 'Pistachio Layer Cake',
    description: 'Moist layers of pistachio cake with creamy pistachio buttercream',
    images: [
      '/cake1.png',
      '/cake2.png',
      '/cake3.png'
    ],
    category: 'Cakes',
    customizable: true
  },
  {
    id: 2,
    name: 'Pistachio Mini Cupcakes',
    description: 'Delicate mini cupcakes topped with creamy pistachio frosting',
    images: [
      '/cupcake2.png',
      '/minicupcake-new.png'
    ],
    category: 'Cupcakes',
    customizable: true
  },
  {
    id: 3,
    name: 'Pistachio Cupcakes',
    description: 'Delicious pistachio cupcakes topped with creamy pistachio frosting',
    images: [
      '/pcupcake1.png',
      '/pcupcake2.jpg',
      '/pcupcake3.png'
    ],
    category: 'Cupcakes',
    customizable: true
  },
  {
    id: 6,
    name: 'Pistachio Tres Leches',
    description: 'Traditional tres leches cake infused with pistachio flavor',
    image: '/tresleches.jpg',
    category: 'Specialty',
    customizable: true
  },
  {
    id: 7,
    name: 'Pistachio Cake Pops',
    description: 'Bite-sized pistachio cake balls on a stick, beautifully decorated',
    image: '/cakepops.png',
    category: 'Cake Pops',
    customizable: true
  },
  {
    id: 8,
    name: 'Mini Pistachio Donuts',
    description: 'Soft mini donuts glazed with pistachio and topped with crushed pistachios',
    image: '/minidonuts.png',
    category: 'Mini Donuts',
    customizable: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    location: 'Clermont, FL',
    text: 'The pistachio layer cake was absolutely divine! You can taste the quality and love in every bite.',
    rating: 5
  },
  {
    id: 2,
    name: 'Michael Torres',
    location: 'Orlando, FL',
    text: 'Ordered cupcakes for my daughter\'s birthday. They were a huge hit! So fresh and delicious.',
    rating: 5
  },
  {
    id: 3,
    name: 'Emily Chen',
    location: 'Winter Garden, FL',
    text: 'The pistachio tres leches is unlike anything I\'ve tasted. Supporting a young entrepreneur makes it even sweeter!',
    rating: 5
  },
  {
    id: 4,
    name: 'David Martinez',
    location: 'Clermont, FL',
    text: 'These cookies are addictive! I love that they\'re all natural and homemade. Will definitely order again.',
    rating: 5
  }
];

export const instagramPosts = [
  {
    id: 1,
    image: '/insta1.png',
    caption: 'Our signature pistachio cakes 🎂'
  },
  {
    id: 2,
    image: '/insta2.png',
    caption: 'Fresh pistachio donuts 🍩'
  },
  {
    id: 3,
    image: '/insta3.png',
    caption: 'Sweet Thank You cups ✨'
  },
  {
    id: 4,
    image: '/cake1.png',
    caption: 'Layer cake love 💚'
  },
  {
    id: 5,
    image: '/cupcake2.png',
    caption: 'Cupcake perfection'
  },
  {
    id: 6,
    image: '/cakepops.png',
    caption: 'Cake pops are here! 🎉'
  }
];
